module.exports = __webpack_public_path__ + "img/img_games_mediaquiz.af1e13cf.png";